import axios from "../api";
export const getCheapestItemScores = async () => {
    const res = await axios.get("/sbcs/cheapest-item-scores");
    return res.data;
};
//# sourceMappingURL=getCheapestItemScores.js.map